import { Button, FormTitle, SubContent, Wrapper, useBreadcrumbRoutes } from '@maxtropy/components';
import styles from './index.module.scss';
import React from 'react';
import { Space, Spin } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { apiV2BsaStrategyTemplateGetPost } from '@maxtropy/intelligent-dispath-apis-v2';

import CommonStrategyDetail from '../components/CommonStrategyDetail';

const routes = [{ name: `查看策略模板` }];

const StrategyTemplateDetail = () => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const bsaId = urlSearchParams.get('bsaId') || undefined;
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data, loading: tableLoading } = useRequest(
    () =>
      apiV2BsaStrategyTemplateGetPost({ id: Number(id) }).then(res => {
        return res;
      }),
    {
      ready: !!id,
      refreshDeps: [id],
    }
  );

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? []), ...routes]} className={styles.wrapper}>
      <FormTitle title={'查看策略模板'}></FormTitle>
      <Spin spinning={tableLoading}>
        <SubContent>
          <CommonStrategyDetail
            showTemplateName={true}
            bsaId={id}
            id={Number(id)}
            data={data as any}
          ></CommonStrategyDetail>
        </SubContent>
        <Space size={8} className="sticky-footer" style={{ zIndex: 99 }}>
          <Button
            className={styles.button}
            onClick={() => navigate(`/ids-energy-storage/basic/bsa/templateList?bsaId=${bsaId}`)}
          >
            返回
          </Button>
        </Space>
      </Spin>
    </Wrapper>
  );
};

export default StrategyTemplateDetail;
